import ClassesDetail from "./ClassesDetail";

export default ClassesDetail;
export { ClassesDetail };
